import { MerchantDashboardWidgetType } from "@redotech/crdb-enums/fulfillment/merchant-dashboard-widget-type";
import { MiniViewSourceTable } from "@redotech/crdb-enums/fulfillment/mini-view-source-table";
import * as z from "zod";
import { ViewColumnSchema } from "./views";

export const MERCHANT_DASHBOARD_GRID_COLUMNS = 12;

export const DEFAULT_MERCHANT_DASHBOARD_NAME = "Dashboard";

export const MINI_VIEW_SUPPORTED_SOURCE_TABLES: readonly MiniViewSourceTable[] =
  [
    MiniViewSourceTable.FulfillmentGroups,
    MiniViewSourceTable.PurchaseOrders,
    MiniViewSourceTable.ReplenishmentRequests,
    MiniViewSourceTable.ReplenishmentReport,
  ];

export const MiniViewSourceTableSchema = z.enum(MiniViewSourceTable);

export const MerchantDashboardWidgetTypeSchema = z.enum(
  MerchantDashboardWidgetType,
);

export const MerchantDashboardWidgetSizeSchema = z.object({
  w: z.number().int().min(1).max(MERCHANT_DASHBOARD_GRID_COLUMNS),
  h: z.number().int().min(1),
});
export type MerchantDashboardWidgetSize = z.infer<
  typeof MerchantDashboardWidgetSizeSchema
>;

export const DEFAULT_MERCHANT_DASHBOARD_WIDGET_SIZE: MerchantDashboardWidgetSize =
  { w: 6, h: 5 };

export const MerchantDashboardWidgetColumnsSchema = z
  .array(ViewColumnSchema)
  .refine(
    (columns) =>
      new Set(columns.map((column) => column.key)).size === columns.length,
    { message: "Widget columns must have unique keys" },
  );
